import { movies } from "@/mocks/catalog";
import type { MovieGenre } from "@/mocks/catalog";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

const featuredGenres: MovieGenre[] = ["科幻片", "动作片", "爱情片", "电视剧", "恐怖片", "喜剧片"];

export default function FeaturedMovies() {
  const featured = featuredGenres
    .map((genre) => movies.find((m) => m.genre === genre))
    .filter((m): m is (typeof movies)[number] => Boolean(m));

  return (
    <section id="featured" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="本周精选"
            title="每个类型，都挑一部值得先看的"
            description="六部作品分别来自六个类型，兼顾口碑与观看体验，适合作为入手该类型的第一部。"
          />
          <a
            href="#explorer"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览全部片库
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}